import { Anchor, Box, Button, Flex, Group, Stack, Text } from '@mantine/core';
import { IconDownload, IconExternalLink, IconPaperclip } from '@tabler/icons-react';
import { formatBytes, type ClientReleaseDto, type FileRefDto } from '@mexp/shared';
import { openFile } from '@/features/files/files';
import { notifyError } from '@/lib/notify';

export const openReleaseFile = (f: FileRefDto, disposition?: 'inline' | 'attachment') =>
  void openFile(f.id, disposition).catch((e) => notifyError(e, 'Could not open the file'));

/** A released version's files (or a compliance's), each with Open and Download, divided by teal hairlines. */
export function ReleaseFiles({ release }: { release: Pick<ClientReleaseDto, 'files' | 'link'> }) {
  return (
    <Box>
      {release.files.map((f) => (
        <Flex
          key={f.id}
          className="portal-delivery-file"
          direction={{ base: 'column', xs: 'row' }}
          justify="space-between"
          align={{ base: 'stretch', xs: 'center' }}
          gap="sm"
          py="sm"
        >
          <Group gap="sm" wrap="nowrap" style={{ minWidth: 0 }}>
            <IconPaperclip size={18} color="var(--mantine-color-teal-light-color)" style={{ flex: 'none' }} />
            <Stack gap={0} style={{ minWidth: 0 }}>
              <Text fz="sm" fw={600} truncate="end">
                {f.name}
              </Text>
              <Text fz="xs" c="var(--mantine-color-teal-light-color)" className="tabular">
                {formatBytes(f.sizeBytes)}
              </Text>
            </Stack>
          </Group>
          <Group gap={6} wrap="nowrap" style={{ flex: 'none' }} className="portal-file-actions">
            <Button size="xs" variant="default" onClick={() => openReleaseFile(f)}>
              Open
            </Button>
            <Button size="xs" color="teal" leftSection={<IconDownload size={14} />} onClick={() => openReleaseFile(f, 'attachment')}>
              Download
            </Button>
          </Group>
        </Flex>
      ))}
      {release.link && (
        <Box className="portal-delivery-file" pt="sm">
          <Anchor href={release.link.url} target="_blank" rel="noopener noreferrer" fz="sm" fw={600} c="var(--mantine-color-teal-light-color)">
            <Group gap={6} wrap="nowrap">
              <IconExternalLink size={16} />
              {release.link.label || 'Open the shared folder'}
            </Group>
          </Anchor>
        </Box>
      )}
    </Box>
  );
}
